import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RedirectIfAuthenticated = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null; // or a loading spinner
  }

  if (user) {
    // If email is not verified, redirect to verification page
    if (!user.emailVerified) {
      return <Navigate to="/verify-email" replace />;
    }
    
    // Otherwise, redirect to the page they came from or dashboard
    const from = location.state?.from?.pathname || '/dashboard';
    return <Navigate to={from} replace />;
  }

  return children;
};

export default RedirectIfAuthenticated;